import dictionary from "./dictionary.json";

export function validWord(word: string) {
  return dictionary.hasOwnProperty(word.toLowerCase());
}
